module.exports = __webpack_public_path__ + "static/media/sk.302f315b.jpg";